import { LoadingIcon } from "@/components/Loading";
import Card from "@/components/ui/Card";
import usePagination from "@/hooks/usePagination";
import { protectedApi } from "@/store/api/api";
import { Icon } from "@iconify/react";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import EditOrganiserModal from "./EditOrganiserModal";

import HomeBredCurbs from "../dashboard/HomeBredCurbs";

const PartnerOrganisersList = () => {
  const [organisers, setOrganisers] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [lastVisibleDocId, setLastVisibleDocId] = useState(null);
  const pageSize = 10; // Define how many items you want per page
  const navigate = useNavigate();
  const { isAdmin, isPartner } = useAuth();
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [selectedOrganiser, setSelectedOrganiser] = useState(null);

  // const {
  //   items: voteTransactions,
  //   isLoading,
  //   hasMore,
  //   loadItems,
  //   metaData,
  // } = usePagination(`/api/categories/${categoryId}/payments`, 10, true);

  const getOrganisers = () => {
    setIsLoading(true);

    const endpoint = lastVisibleDocId
      ? `/api/organisers/all?pageSize=${pageSize}&lastVisibleDocId=${lastVisibleDocId}`
      : `/api/organisers/all?pageSize=${pageSize}`;

    protectedApi
      .get(endpoint)
      .then((res) => {
        const data = res.data.data;
        setOrganisers((prev) => [...prev, ...data]);
        if (data.length > 1) setLastVisibleDocId(data[data.length - 1].id);
      })
      .catch((err) => console.error("Error fetching organisers:", err))
      .finally(() => setIsLoading(false));
  };

  useEffect(() => {
    getOrganisers(pageNumber);
  }, []);

  const handleEditClick = (organiser) => {
    setSelectedOrganiser(organiser);
    setIsEditModalOpen(true);
  };

  const handleEditSuccess = () => {
    // Reset and reload organisers
    setOrganisers([]);
    setLastVisibleDocId(null);
    getOrganisers(1);
  };

  if (isLoading)
    return (
      <Card className="flex items-center h-screen justify-center">
        <LoadingIcon />
      </Card>
    );

  return (
    <div>
      <div className="space-y-5">
        <HomeBredCurbs title="all Organisers List" showDatepicker={false} />
        <Card>
          <div className="overflow-x-auto">
            <table className="min-w-full divide-slate-100 table-fixed dark:divide-slate-700">
              <thead className="border-t border-slate-100 dark:border-slate-800">
                <tr className="w-full">
                  <th className="table-th px-3 py-3 font-medium text-left text-gray-900 whitespace-nowrap">
                    #
                  </th>
                  <th className="table-th px-3 py-3 font-medium text-left text-gray-900 whitespace-nowrap">
                    First Name
                  </th>
                  <th className="table-th px-3 py-3 font-medium text-left text-gray-900 whitespace-nowrap">
                    Last Name
                  </th>
                  <th className="table-th px-3 py-3 font-medium text-left text-gray-900 whitespace-nowrap">
                    Phone
                  </th>
                  <th className="table-th px-6 py-3 font-medium text-left text-gray-900 whitespace-nowrap">
                    Email
                  </th>
                  <th></th>
                </tr>
              </thead>
              <tbody className="text-gray-600 text-sm font-light">
                {organisers.map((item, index) => (
                  <tr
                    key={item.id}
                    className="border-b border-gray-200 hover:bg-gray-100"
                  >
                    <td className="px-3 py-4 whitespace-nowrap">{index + 1}</td>
                    <td className="px-3 py-4 whitespace-nowrap">
                      {item.firstName || item.name}
                    </td>
                    <td className="px-3 py-4 whitespace-nowrap">
                      {item.lastName || ""}
                    </td>
                    <td className="px-3 py-4 whitespace-nowrap">
                      {item.phone || ""}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      {item.email}
                    </td>
                    <td>
                      <div className="flex gap-2 items-center">
                        {(isAdmin || isPartner) && (
                          <button
                            type="button"
                            className="btn btn-sm btn-outline-primary"
                            onClick={() => handleEditClick(item)}
                            title="Edit Organiser"
                          >
                            <Icon icon="heroicons:pencil-square" className="w-4 h-4" />
                          </button>
                        )}
                        <button
                          type="button"
                          className="bg-green-500 py-2 px-4 text-white rounded-md hover:bg-green-600 hover:text-white transition-colors duration-300 ease-in-out border border-green-500 flex items-center justify-center gap-2"
                          onClick={() => {
                            navigate(`/partners/organisers/${item.id}`);
                          }}
                        >
                          <span>View Events</span>
                        </button>
                        {/* <button
                          type="button"
                          className="btn btn-primary text-center py-2 px-4 text-white rounded-md transition-colors duration-300 ease-in-out border flex items-center justify-center gap-2"
                          onClick={() => {
                            navigate(`/partners/organisers/payouts/${item.id}`);
                          }}
                        >
                          <span>View Payouts</span>
                        </button> */}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </Card>
      </div>
      <EditOrganiserModal
        isOpen={isEditModalOpen}
        onClose={() => {
          setIsEditModalOpen(false);
          setSelectedOrganiser(null);
        }}
        organiser={selectedOrganiser}
        onSuccess={handleEditSuccess}
      />
    </div>
  );
};

export default PartnerOrganisersList;
